/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { linkStyles, textStyles  } from "utils/themeV2";


/* ++++++++++ --------------- EXPORT : AUTH PASSWORD UPDATED : STYLES --------------- ++++++++++ */
export default theme => ({
	passwordupdated: {
        ...linkStyles,
        ...textStyles
	}
});
